import { Injectable } from '@angular/core';
import { CanActivate } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { Router } from '@angular/router';
import { AppState, selectOrderCreation, OrderCreationState } from "@store/reducers";
import { Store } from "@ngrx/store";
import 'rxjs/add/operator/map';

@Injectable()
export class OrderSummaryGuard implements CanActivate {
  constructor(
    private router: Router,
    private store: Store<AppState>,
  ) {}

  canActivate(): Observable<boolean> {
      return this.checkStore();
  }

  checkStore(): Observable<boolean> {
    return this.store.select(selectOrderCreation)
      .map((data: OrderCreationState) => {
        if (!!Object.keys(data.shipments).length) {
          return true;
        } else {
          this.router.navigate(['create-consignment', 'search-result']);
          return false;
        }
      })
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/consignment/services/order-summary.guard.ts